'use client';

export function PageHeroBackground() {
  return (
    <>
      <div className="absolute inset-0 overflow-hidden rounded-t-layout-lg bg-purple-1000 motion-reduce:hidden">
        <div className="absolute inset-0 blur-[80px]">
          <div className="animate-hero-morph -translate-x-[22%] size-full opacity-80 bg-[radial-gradient(circle,var(--color-purple-700)_0%,transparent_90%)]" />
        </div>
        <div className="absolute inset-0 blur-[80px]">
          <div className="animate-hero-morph translate-x-[22%] size-full opacity-80 bg-[radial-gradient(circle,var(--color-purple-700)_0%,transparent_70%)] [animation-duration:11s] [animation-delay:-3s]" />
        </div>
      </div>
      <div className="absolute inset-0 rounded-t-layout-lg bg-radial-[at_92.09%_73.28%] from-purple-700 to-purple-1000 motion-safe:hidden" />
    </>
  );
}
